type TariffDefinition = {
  pricePerHour: number | null;
  timeFrom: string;
  timeTo: string;
  [key: string]: any;
};

type TariffGroup = {
  activeTariffDefinitions: TariffDefinition[];
  [key: string]: any;
};

type TariffInfo = {
  activeTariffGroups: TariffGroup[];
  [key: string]: any;
};

/**
 * Seřadí tarify v ceníku (TariffInfo) tak, aby tarif s pricePerHour = 0 (první hodina zdarma)
 * byla vždy až pod jinými definicemi se stejným časovým rozsahem.
 */
export const sortTariffDefinitions = (tariffInfo: TariffInfo): TariffInfo => {
  return {
    ...tariffInfo,
    activeTariffGroups: tariffInfo.activeTariffGroups.map(group => ({
      ...group,
      activeTariffDefinitions: [...group.activeTariffDefinitions].sort((a, b) => {
        if (a.timeFrom === b.timeFrom && a.timeTo === b.timeTo) {
          const aIsFree = a.pricePerHour === 0;
          const bIsFree = b.pricePerHour === 0;
          if (aIsFree && !bIsFree) return 1;
          if (!aIsFree && bIsFree) return -1;
        }
        return 0;
      }),
    })),
  };
};